import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SettingsService } from '@app/settings.service';

import * as sharedModels from '@shared/models';

import * as models from '../models';

@Injectable({
  providedIn: 'root',
})
export class AgentScoreService {
  constructor(
    private http: HttpClient,
    private settingsService: SettingsService,
  ) {}

  getAgentScore(id: models.GetAgentScoreParams): Observable<models.AgentScore[]> {
    const currentLanguageAsKey = this.settingsService.getCurrentLanguageAsKey();
    return this.http.get<models.RawAgentScore>(`${environment.apiDataManagerUrl}/open-api/application-feedback/agentAgentScores/${id}`).pipe(
      map((res) =>
        res.map((score) => {
          if (
            score?.agentScoreDto &&
            score?.agentScoreDto?.id &&
            score?.agentScoreDto?.nameEn &&
            score?.agentScoreDto?.nameRu &&
            score?.agentScoreDto?.nameKz &&
            score?.agentScoreDto?.photoUuid &&
            (score?.count === 0 || score?.count)
          ) {
            const name: sharedModels.Localization = { nameEn: score.agentScoreDto.nameEn, nameRu: score.agentScoreDto.nameRu, nameKz: score.agentScoreDto.nameKz };
            return new models.AgentScore({
              id: score.agentScoreDto.id,
              name: name[currentLanguageAsKey as keyof sharedModels.Localization],
              nameIcon: name.nameEn.toLocaleLowerCase().replace(/ /g, '-'),
              icon: score.agentScoreDto.photoUuid,
              count: score.count,
            });
          } else {
            throw new Error('Invalid agent score');
          }
        }),
      ),
    );
  }

  getAgentClientScore(id: models.GetAgentClientScoresParams): Observable<models.AgentScore[]> {
    const currentLanguageAsKey = this.settingsService.getCurrentLanguageAsKey();
    return this.http.get<models.RawAgentClientScore>(`${environment.apiUserManagerUrl}/open-api/users/categories/${id}`).pipe(
      map((res) =>
        res.map((score) => {
          if (
            score?.agentScore &&
            score?.agentScore?.id &&
            score?.agentScore?.nameEn &&
            score?.agentScore?.nameRu &&
            score?.agentScore?.nameKz &&
            score?.agentScore?.photoUuid &&
            (score?.count === 0 || score?.count)
          ) {
            const name: sharedModels.Localization = { nameEn: score.agentScore.nameEn, nameRu: score.agentScore.nameRu, nameKz: score.agentScore.nameKz };
            return new models.AgentScore({
              id: score.agentScore.id,
              name: name[currentLanguageAsKey as keyof sharedModels.Localization],
              nameIcon: name.nameEn.toLocaleLowerCase().replace(/ /g, '-'),
              icon: score.agentScore.photoUuid,
              count: score.count,
            });
          } else {
            throw new Error('Invalid agent client score');
          }
        }),
      ),
    );
  }
}
